import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotifierService {
  constructor(private notifier: MessageService) { }

  public error(summary: string, notificationId?: string) {
    this.notifier.add({ severity: 'error', summary, id: notificationId });
  }

  public exception(error: any) {
    this.notifier.add({ severity: 'error', summary: error.message || error.error.message || error.error || 'Something went wrong. Please try again later.' });
  }

  public success(summary: string, notificationId?: string) {
    this.notifier.add({ severity: 'success', summary, id: notificationId });
  }

  public clickable(
    summary: string,
    onClick?: (event: MouseEvent) => void,
    notificationId?: string,
  ) {
    const formattedMessage = onClick
      ? `<span class="clickable-notification" (click)="onClick($event)">${summary}</span>`
      : summary;
    this.notifier.add({ severity: 'success', summary: formattedMessage, id: notificationId });
  }
  public info(summary: string, notificationId?: string) {
    this.notifier.add({ severity: 'info', summary, id: notificationId });
  }

  public warning(summary: string, notificationId?: string) {
    this.notifier.add({ severity: 'secondary', summary, id: notificationId });
  }
}
